import { FC, useRef, useEffect, useCallback, useContext, HTMLAttributes } from 'react'
import { OuterEventTrackerContext } from 'components/utils/OuterEventTracker'

type OuterEventComponentProps =
  & HTMLAttributes<HTMLDivElement>
  & {
    innerRef?: (ref: HTMLDivElement) => void
    onOuterClick?: (event: KeyboardEvent) => void
    onOuterTap?: (event: KeyboardEvent) => void
    onOuterESC?: (event: KeyboardEvent) => void
  }

export const OuterEvent: FC<OuterEventComponentProps> = (props) => {
  const {
    innerRef,
    children,
    onOuterClick,
    onOuterTap,
    onOuterESC,
    ...restProps
  } = props

  const rootRef = useRef<HTMLDivElement>()
  const handleRef = useCallback<(ref: HTMLDivElement | null) => void>((ref) => {
    rootRef.current = ref || undefined
    innerRef && ref && innerRef(ref)
  }, [innerRef])
  const rootNode = rootRef.current

  const handleESC = useCallback<(event: KeyboardEvent) => void>((event) => {
    if (onOuterESC && event.key === 'Escape') {
      onOuterESC(event)
    }
  }, [onOuterESC])

  const outerEventTracker = useContext(OuterEventTrackerContext)

  useEffect(() => {
    if (!rootNode) {
      return
    }

    if (onOuterClick) {
      outerEventTracker.addOuterEventListener('click', onOuterClick, rootNode)
    }
    if (onOuterTap) {
      outerEventTracker.addOuterEventListener('tap', onOuterTap, rootNode)
    }
    if (onOuterESC) {
      outerEventTracker.addOuterEventListener('keydown', handleESC, rootNode)
    }

    return () => {

      if (onOuterClick) {
        outerEventTracker.removeOuterEventListener('click', onOuterClick)
      }
      if (onOuterTap) {
        outerEventTracker.removeOuterEventListener('tap', onOuterTap)
      }
      if (onOuterESC) {
        outerEventTracker.removeOuterEventListener('keydown', handleESC)
      }
    }
  }, [rootNode, onOuterClick, onOuterTap, onOuterESC, outerEventTracker, handleESC])

  return (
    <div ref={ handleRef } data-outer-event { ...restProps }>
      { children }
    </div>
  )
}
